import * as React from "react";
const SvgChevronBottom = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 8, viewBox: "0 0 8 6", fill: "#666666", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.94 0.530273L4 3.58361L7.06 0.530273L8 1.47027L4 5.47027L0 1.47027L0.94 0.530273Z" }));
export default SvgChevronBottom;
